export default obj => (document.title = obj.brandID);
